import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for ClashPanelActions component
 * Provides filter dropdown, actions container, and menu styling
 */
export const useClashPanelActionsStyles = makeStyles((theme: Theme) => ({
    actionsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: 0,
        flex: 1,
    },
    toggleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingBottom: theme.spacing(1.5),
    },
    actionButtonGrid: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    moreIcon: {
        fill: '#185E8E',
        padding: theme.spacing(0.5),
    },
    filterSelect: {
        background: theme.palette.common.white,
        border: 'none',
        borderRadius: pxToRem(3.5),
        width: '100%',
        height: pxToRem(30),
        fontSize: pxToRem(12),
        paddingLeft: theme.spacing(0.5),
        '&:focus': {
            backgroundColor: theme.palette.common.white,
            outline: 'none',
        },
    },
    selectOutlined: {
        padding: theme.spacing(1.5, 4, 1.25, 1),
    },
    filterOptionItem: {
        fontSize: pxToRem(12),
        fontFamily: 'Roboto',
        fontWeight: 400,
    },
    menuItem: {
        fontSize: pxToRem(12),
        fontFamily: 'Roboto',
        fontWeight: 400,
    },
}))
